import { defineComponent, computed, useSlots, createElementBlock, openBlock, normalizeClass, createBlock, createCommentVNode, withCtx, createTextVNode, toDisplayString, resolveDynamicComponent, renderSlot, normalizeProps, mergeProps } from 'vue';
import _sfc_main$1 from './basler-components.es70.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import { useSlotContent } from './basler-components.es386.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeadlineModule",
  props: {
    level: {},
    tag: {},
    styleType: {},
    modifier: {},
    badgeText: { default: "" },
    badgeSize: {},
    badgeStyle: { default: "primary" },
    isCentered: { type: Boolean, default: false },
    icon: {},
    content: { default: "" }
  },
  setup(__props) {
    const props = __props;
    const tag = computed(() => {
      return props.tag || `h${props.level}`;
    });
    const badgeSize = computed(() => {
      if (props.badgeSize) {
        return props.badgeSize;
      }
      return props.level < 3 ? "large" : "medium";
    });
    const styleType = computed(() => {
      let styleType2 = "";
      if (props.styleType) {
        styleType2 = props.styleType;
      } else {
        styleType2 = `h${props.level}`;
      }
      return styleType2;
    });
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasDefaultSlotContent = computed(() => {
      return hasSlotContent(slots.default);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["headline-module", { "is-centered": _ctx.isCentered }])
      }, [
        _ctx.badgeText ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          size: badgeSize.value,
          "is-rounded": true,
          "badge-style": _ctx.badgeStyle
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.badgeText), 1)
          ]),
          _: 1
        }, 8, ["size", "badge-style"])) : createCommentVNode("", true),
        _ctx.icon || hasDefaultSlotContent.value || _ctx.content ? (openBlock(), createBlock(resolveDynamicComponent(tag.value), {
          key: 1,
          class: normalizeClass(["headline-module__text", styleType.value, { "align--center": _ctx.isCentered }])
        }, {
          default: withCtx(() => [
            hasDefaultSlotContent.value || _ctx.content ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["headline-module__text-inner", { [`is-${_ctx.modifier}`]: _ctx.modifier }])
            }, [
              _ctx.icon ? (openBlock(), createBlock(_sfc_main$2, normalizeProps(mergeProps({ key: 0 }, _ctx.icon)), null, 16)) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "default", {}, () => [
                createTextVNode(toDisplayString(_ctx.content), 1)
              ])
            ], 2)) : createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["class"])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
